// extracted by mini-css-extract-plugin
module.exports = {"modal__heading":"deleteModal_modal__heading__sbQ28","modal__remainbutton":"deleteModal_modal__remainbutton__1rrMN","modal__deletebutton":"deleteModal_modal__deletebutton__28Xqm"};